import { ADJUSTMENT_DRAFT_STATUS } from '@/utils/enum'

const S = ADJUSTMENT_DRAFT_STATUS

const ISSUED_STATUSES = Object.freeze([S.ISSUED, S.FAST_SYNCED])
const FAILED_STATUSES = Object.freeze([S.ISSUE_FAILED, S.FAST_SYNC_FAILED])
const IN_PROGRESS_STATUSES = Object.freeze([
  S.ISSUING,
  S.RETRYING,
  S.WAITING_PROVIDER,
  S.FAST_SYNCING,
])

function includesStatus(statuses, status) {
  return status != null && statuses.includes(status)
}

/** Nhãn gọn trên danh sách/chi tiết HĐĐT — nhấn mạnh đã/đang điều chỉnh GTGT */
export function getEinvoiceAdjustmentDraftBadgeClass(status) {
  if (includesStatus(ISSUED_STATUSES, status)) return 'badge-success'
  if (includesStatus(FAILED_STATUSES, status)) return 'badge-danger'
  if (includesStatus(IN_PROGRESS_STATUSES, status)) return 'badge-primary'
  return 'badge-secondary'
}

export function getEinvoiceAdjustmentDraftBadgeLabel(status) {
  if (includesStatus(ISSUED_STATUSES, status)) return 'Đã điều chỉnh'
  if (includesStatus(FAILED_STATUSES, status)) return 'Điều chỉnh thất bại'
  if (includesStatus(IN_PROGRESS_STATUSES, status)) return 'Đang điều chỉnh'
  return 'Nháp điều chỉnh'
}
